/**
 * Passwortfeld mit „Zeigen".
 *
 * Aus dem Entwurf übernommen, und zwar aus einem handfesten Grund: Ein Feld,
 * das nur Punkte zeigt, ist die häufigste Ursache einer fehlgeschlagenen
 * Anmeldung, die keine ist. Wer sich vertippt, sieht es sonst nirgends.
 *
 * Drei Dinge, die man dabei falsch macht:
 *
 * **`type="button"`.** Ohne die Angabe ist ein Knopf in einem Formular ein
 * Absendeknopf — „Zeigen" schickte dann die Anmeldung ab.
 *
 * **`aria-pressed` statt einer Beschriftung, die sich nicht ändert.** Der Text
 * wechselt zwischen „Zeigen" und „Verbergen"; eine Sprachausgabe liest damit
 * beides — den Zustand und die nächste Handlung.
 *
 * **Sichtbar bleibt es nicht.** Beim Absenden fällt die Sichtbarkeit nicht von
 * selbst zurück, wohl aber beim nächsten Aufbau der Seite; ein Passwort, das
 * nach dem Wechsel zwischen Anmelden und Registrieren offen stünde, hätte
 * niemand so entschieden.
 */
import { Input, type InputProps } from "@hausmeter/ui";
import { useState } from "react";

export type PasswordFieldProps = Omit<InputProps, "type" | "trailing">;

export function PasswordField({ label, ...rest }: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);

  return (
    <Input
      {...rest}
      label={label}
      type={visible ? "text" : "password"}
      trailing={
        <button
          type="button"
          aria-pressed={visible}
          aria-label={visible ? "Passwort verbergen" : "Passwort im Klartext zeigen"}
          onClick={() => setVisible((wert) => !wert)}
          style={{
            font: "inherit",
            fontSize: 13,
            fontWeight: 600,
            color: "var(--text-brand)",
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
        >
          {visible ? "Verbergen" : "Zeigen"}
        </button>
      }
    />
  );
}
